import React from "react";

export function AdminLoadingStyles() {
  return (
    <style>{`
      .admin-loadingbar-wrap{
        height: 3px; border-radius: 999px; background: #eef2ff;
        overflow: hidden; margin-top: 10px;
      }
      .admin-loadingbar{
        height: 100%;
        width: 40%;
        background: #111827;
        transform: translateX(-120%);
        animation: adminbar 1.1s infinite;
      }
      @keyframes adminbar{
        0%{ transform: translateX(-120%); opacity: .35; }
        50%{ opacity: .9; }
        100%{ transform: translateX(260%); opacity: .35; }
      }
      .admin-spinner{
        width: 14px; height: 14px; border-radius: 999px;
        border: 2px solid #e5e7eb; border-top-color: #111827;
        animation: adminspin .8s linear infinite;
        display: inline-block;
      }
      @keyframes adminspin{
        from{ transform: rotate(0deg); }
        to{ transform: rotate(360deg); }
      }
    `}</style>
  );
}

export function AdminSpinner({ loading, title = "Loading" }) {
  if (!loading) return null;
  return <span className="admin-spinner" title={title} />;
}

export function AdminLoadingBar({ loading, title = "Loading" }) {
  if (!loading) return null;
  return (
    <div className="admin-loadingbar-wrap" title={title}>
      <div className="admin-loadingbar" />
    </div>
  );
}
